import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Rectangle, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

// Fix for default marker icons in react-leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const HeatLegend = () => {
  return (
    <div className="absolute bottom-4 right-4 bg-white p-3 rounded-lg shadow-lg border border-[var(--border-color)] z-[1000]">
      <div className="text-xs font-semibold mb-2">DemandIndex</div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <div className="w-8 h-3 bg-green-200" />
          <span className="text-xs">0.0 - 0.3 Low</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-3 bg-yellow-300" />
          <span className="text-xs">0.3 - 0.5 Medium</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-3 bg-orange-400" />
          <span className="text-xs">0.5 - 0.7 High</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-3 bg-red-500" />
          <span className="text-xs">0.7 - 1.0 Very High</span>
        </div>
      </div>
    </div>
  );
};

const getColorForDemandIndex = (demandIndex) => {
  if (demandIndex < 0.3) return '#bbf7d0'; // green-200
  if (demandIndex < 0.5) return '#fde047'; // yellow-300
  if (demandIndex < 0.7) return '#fb923c'; // orange-400
  return '#ef4444'; // red-500
};

const DsatHeatmap = ({ cells, onCellClick }) => {
  const [selectedCell, setSelectedCell] = useState(null);

  // Center map on India (Delhi)
  const center = [28.6139, 77.2090];

  const handleCellClick = (cell) => {
    setSelectedCell(cell);
    if (onCellClick) {
      onCellClick(cell);
    }
  };

  // Approximate geohash-6 to bounds (simplified - in production use actual geohash library)
  const geohashToBounds = (geohash, lat, lng) => {
    const size = 0.02; // Approximate size for geohash-6 cell
    return [
      [lat - size, lng - size],
      [lat + size, lng + size]
    ];
  };

  return (
    <div className="relative h-[600px] w-full rounded-lg overflow-hidden border border-[var(--border-color)]">
      <MapContainer
        center={center}
        zoom={11}
        style={{ height: '100%', width: '100%' }}
        className="z-0"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {cells.map((cell) => {
          const bounds = geohashToBounds(cell.cell, cell.lat || 28.6139, cell.lng || 77.2090);
          const color = getColorForDemandIndex(cell.demand_index);
          
          return (
            <Rectangle
              key={cell.cell}
              bounds={bounds}
              pathOptions={{
                color: color,
                fillColor: color,
                fillOpacity: 0.6,
                weight: 2
              }}
              eventHandlers={{
                click: () => handleCellClick(cell)
              }}
            >
              <Popup>
                <div className="text-sm">
                  <div className="font-semibold mb-1">{cell.cell}</div>
                  <div className="text-xs space-y-1">
                    <div>City: {cell.city}</div>
                    <div>DemandIndex: <span className="font-semibold">{cell.demand_index}</span></div>
                    <div>Type: <span className="font-semibold">{cell.recommend_type.toUpperCase()}</span></div>
                    <div>Strategy: <span className="font-semibold">{cell.recommend_own_or_enroll.toUpperCase()}</span></div>
                  </div>
                  <button
                    onClick={() => handleCellClick(cell)}
                    className="mt-2 w-full px-2 py-1 text-xs bg-[var(--gg-purple)] text-white rounded hover:bg-[var(--gg-purple)]/90"
                  >
                    View Details
                  </button>
                </div>
              </Popup>
            </Rectangle>
          );
        })}
      </MapContainer>
      
      <HeatLegend />
    </div>
  );
};

export default DsatHeatmap;
